import { Component, Signal, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SelectButtonModule } from 'primeng/selectbutton';
import { DrawerModule } from 'primeng/drawer';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MenuItem } from 'primeng/api';

import { LayoutService } from '@core/service/layout.service';
import { LayoutConfig } from '@core/type/layout';

@Component({
  selector: 'app-configurator',
  templateUrl: './configurator.component.html',
  imports: [FormsModule, SelectButtonModule, DrawerModule, RadioButtonModule],
})
export class ConfiguratorComponent {
  protected themeOptions: Array<MenuItem> = [
    { name: 'Claro', value: false },
    { name: 'Oscuro', value: true },
  ];

  protected darkTheme: Signal<boolean> = computed(() => this.layoutService.layoutConfig().darkTheme);
  protected menuMode: Signal<LayoutConfig['menuMode']> = computed(() => this.layoutService.layoutConfig().menuMode);
  protected visible: Signal<boolean> = computed(() => this.layoutService.layoutState().configSidebarVisible);

  constructor(private readonly layoutService: LayoutService) {}

  protected onDrawerHide(): void {
    this.layoutService.hideConfigSidebar();
  }

  protected setMenuMode(mode: LayoutConfig['menuMode']): void {
    this.layoutService.layoutConfig.update(state => ({
      ...state,
      menuMode: mode,
    }));

    if (this.menuMode() === 'static') {
      this.layoutService.layoutState.update(state => ({
        ...state,
        staticMenuDesktopInactive: false,
      }));
    }
  }

  protected toggleDarkMode(): void {
    this.executeDarkModeToggle();
  }

  private executeDarkModeToggle(): void {
    this.layoutService.layoutConfig.update(state => ({
      ...state,
      darkTheme: !state.darkTheme,
    }));

    this.layoutService.updateBodyBackground();
  }
}
